import React, { useState, useContext } from 'react';
import '../FormStyles/FormStyles.css';
import { DynamicContext } from '../../Context/DynamicContext';

/**
 * TextInput - A standardized text input component
 * 
 * @param {Object} props
 * @param {string} props.label - Input label
 * @param {string} props.name - Input name
 * @param {string} props.value - Input value
 * @param {Function} props.onChange - Change handler
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.type - Input type (text, password, email, etc)
 * @param {boolean} props.required - Whether input is required
 * @param {boolean} props.error - Whether input has an error
 * @param {string} props.errorMessage - Error message to display
 * @param {boolean} props.disabled - Whether input is disabled
 * @param {boolean} props.readOnly - Whether input is read-only
 */
const TextInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  type = 'text',
  required = false,
  showPasswordToggle = false,
  error = false,
  errorMessage = '',
  disabled = false,
  readOnly = false,
  className = '',
  containerStyle = {},
  inputStyle = {},
  labelStyle = {},
  inputProps,
  ...rest
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { isDarkMode } = useContext(DynamicContext);

  const handleTogglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className="form-field" style={containerStyle}>
      {label && (
        <label 
          htmlFor={name} 
          className={`form-label ${required ? 'required-field' : ''}`}
          style={labelStyle}
        >
          {label}
        </label>
      )}
      <div className="input-wrapper" style={{ position: 'relative' }}>
        <input
          id={name}
          name={name}
          type={showPasswordToggle && isPasswordVisible ? 'text' : type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          className={`form-input ${error ? 'error' : ''} ${className}`}
          style={inputStyle}
          {...rest}
        />
        
        {showPasswordToggle && type === 'password' && (
          <button
            type="button"
            onClick={handleTogglePasswordVisibility}
            className="password-toggle"
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {isPasswordVisible ? 'Hide' : 'Show'}
          </button>
        )}
      </div>
      
      {error && errorMessage && (
        <div className="error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default TextInput; 